import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";
import { Transport } from "interfaces/transport";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_TRANSPORT_" }
);

export interface FetchTransportState extends IState {
  data: Transport | null;
}

export interface FetchTransportSuccess extends ISuccessAction {
  data: Transport;
}

const INITIAL_STATE: FetchTransportState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchTransportState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FetchTransportState, action: FetchTransportSuccess) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: FetchTransportState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchTransport = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchTransportTypes = Types;
export const FetchTransportActions = Creators;
